import { TYPE_MATRIX_ITEMS, TYPE_PRODUCTS } from "../../Constants"
import { ProductDto, initialProductState } from "../../Product"
import { MATRIX_ITEM_STATUS } from "../../Types"

export type MatrixItemDtoAttributes = {
    status_: MATRIX_ITEM_STATUS
    product: ProductDto
    productId: string
    matrixId: string
    deleted: boolean
    variantId?: string
    variantName?:string
    xMatrixAxisOptionId: string
    yMatrixAxisOptionId: string
    zMatrixAxisOptionId: string
}

export type MatrixItemDto = {
    id: string
    type: string
    attributes: MatrixItemDtoAttributes
}

export const initialMatrixItem: MatrixItemDto = {
    id: "",
    type: TYPE_MATRIX_ITEMS,
    attributes: {
        status_: MATRIX_ITEM_STATUS.NEW,
        matrixId: "",
        xMatrixAxisOptionId: "",
        yMatrixAxisOptionId: "",
        zMatrixAxisOptionId: "",
        deleted: false,
        productId: "",
        product: {
            id: "",
            type: TYPE_PRODUCTS,
            attributes: initialProductState
        }
    }
}


// WEBPACK FOOTER //
// ./src/state/product/matrix/matrix-item/MatrixItem.ts